import React, { useEffect, useState } from 'react';
import "./ConcertCalendar.css";

const ConcertCalendar = () => {
  const [concerts, setConcerts] = useState([]);
  const [selectedBorough, setSelectedBorough] = useState("All");
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isNextWeek, setIsNextWeek] = useState(false);
  const [weekOffset, setWeekOffset] = useState(0); // Starts at 0 (current week), can go up to 2 (two weeks ahead)
  const [isAnimationComplete, setIsAnimationComplete] = useState(false);
  const BASE_URL = '';
  const isMobile = window.innerWidth <= 768;

  const formatDate = (date) => {
    return `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${(
      "0" + date.getDate()
    ).slice(-2)}`;
  };


  // New function for displaying dates in the UI
  const formatDisplayDate = (date) => {
    return `${date.getMonth() + 1}/${date.getDate()}`;
  };

  const getDisplayText = (date, bgColor) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    if (date.toDateString() === today.toDateString()) {
        return (
            <span style={{ color: "#ADD8E6" }}>
                Shows in NYC Today ({formatDisplayDate(date)})
            </span>
        );
    } else if (date.toDateString() === tomorrow.toDateString()) {
        return (
            <span style={{ color: "#FC7C12" }}>
                And Tomorrow ({formatDisplayDate(date)})...
            </span>
        );
    } else {
        const textColor = bgColor === "#F0D878" ? "#FF00FF" : 
                          bgColor === "#A1CFCF" ? "#FC7C12" : 
                          bgColor === "#8FBC8F" ? "#8931e8" :
                          bgColor === "#E6A8B8" ? "#2F4F4F" :
                          bgColor === "#333333" ? "#ADD8E6" :
                          "white";

        return (
            <span style={{ color: textColor }}>
                Shows on {date.toLocaleDateString("en-US", { weekday: "short" })} ({formatDisplayDate(date)})
            </span>
        );
    }
};

  useEffect(() => {
    const formattedDate = formatDate(selectedDate);
    fetch(`${BASE_URL}/api/shows/?date=${formattedDate}`)
      .then((response) => response.json())
      .then((data) => setConcerts(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, [selectedDate]);

// Handle button animations on mount
  useEffect(() => {
    const buttons = document.querySelectorAll('.button');
    buttons.forEach((button, index) => {
      //const directions = ['animate-fly-in-left', 'animate-fly-in-right', 'animate-fly-in-top', 'animate-fly-in-bottom'];
      const directions = [
        'animate-fly-in-left-diagonal', 
        'animate-fly-in-right-diagonal', 
        'animate-fly-in-bottom-left', 
        'animate-fly-in-bottom-right'
      ];
     

      const randomDirection = directions[index % directions.length];
      setTimeout(() => {
        button.classList.add(randomDirection);
      }, index * 100);
    });

    setTimeout(() => {
      setIsAnimationComplete(true);
    }, 1000);
  }, []);



  const boroughs = [
    "All",
    "Manhattan",
    "Brooklyn",
    "Queens",
    "Bronx",
    "Staten Island",
  ];

  

  const handleBoroughChange = (e) => {
    setSelectedBorough(e.target.value);
  };

  const handleButtonClick = (callback) => {
    if (isAnimationComplete) {
       callback();
    }
  };



const colorMap = [
    "#A586C0", // muted purple for day 1 baby
    "#A1CFCF", // // Muted Turquoise
    "#8FBC8F",  // Muted Green     
    "#F0D878",  // Softer Yellow (New) 
    "#E6A8B8",  //  Muted Pink 
    "rgba(51, 51, 51, 1)",  // Muted Purple                
    "#E57373",  // Muted Red          
];
/*
const colorMap = [
  "rgba(51, 51, 51, 0.92)",
  "rgba(161, 207, 207, 0.90)",
  "rgba(143, 188, 143, 0.90)",
  "rgba(240, 216, 120, 0.90)",
  "rgba(230, 168, 184, 0.90)",
  "rgba(165, 134, 192, 0.90)",
  "rgba(229, 115, 115, 0.90)",
];
*/
  const [selectedColor, setSelectedColor] = useState(colorMap[0]); // Default to grey

const getTextColor = (bgColor) => {
  return bgColor === "rgba(51, 51, 51, 1)" ? "white" : "black";
};

const getVenueColor = (bgColor) => {
  return bgColor === "#A586C0" || bgColor === "rgba(51, 51, 51, 1)" ? "#ADD8E6" : "#0202f7";
};
  

  const handleDateChange = (date,index) => {
    setSelectedDate(date);
    setSelectedColor(colorMap[index % colorMap.length]);
  };

  const handleWeekChange = (direction) => {
    setWeekOffset((prevOffset) => {
      let newOffset = prevOffset;
      if (direction === "next" && prevOffset < 2) {
        newOffset = prevOffset + 1;
      } else if (direction === "previous" && prevOffset > 0) {
        newOffset = prevOffset - 1;
      }
      // Assuming the start of the week is what we want to display
      const newWeekDays = getWeekDays(newOffset);
      setSelectedDate(newWeekDays[0]);
      setSelectedColor(colorMap[0]); // Reset to grey
      return newOffset;
    });
  };
    const getWeekDays = (offset = weekOffset) => {
    const start = new Date(currentWeek);
    start.setDate(start.getDate() + offset * 7);
    return Array.from({ length: 7 }).map((_, index) => {
      const date = new Date(start);
      date.setDate(start.getDate() + index);
      return date;
    });
  };

  const getFilteredConcerts = () => {
    if (selectedBorough === "All") {
      return concerts.reduce((acc, concert) => {
        const borough = concert.venue_name.borough.name;
        if (!acc[borough]) {
          acc[borough] = [];
        }
        acc[borough].push(concert);
        return acc;
      }, {});
    } else {
      return {
        [selectedBorough]: concerts.filter(
          (concert) => concert.venue_name.borough.name === selectedBorough
        ),
      };
    }
  };

  const filteredConcerts = getFilteredConcerts();

  const formatShowTime = (timeString) => {
  if (!timeString) return null;

  const [hour, minute] = timeString.split(":");
  const date = new Date();
  date.setHours(parseInt(hour, 10));
  date.setMinutes(parseInt(minute, 10));

  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
};

const makeTransparent = (color) => {
  if (color.startsWith("rgba")) {
    return color.replace(/,\s*1\)/, ", 0.80)");
  }

  const hex = color.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, 0.89)`;
};

const getShowAccentColor = (bgColor) => {
  if (bgColor === "#A1CFCF") return "#F58426"; // blue day -> orange
  if (bgColor === "#8FBC8F") return "#8931e8"; // green day -> purple
  if (bgColor === "#F0D878") return "#FF00FF"; // yellow day -> pink
  return "#ff2b63"; // default red
};

return (
	<div
  className="concert-calendar"
	style={{
  backgroundColor: isMobile
    ? selectedColor
    : makeTransparent(selectedColor),
  color: getTextColor(selectedColor)
}}
>
    
     <h3>{getDisplayText(selectedDate, selectedColor)}</h3>
      {boroughs.map((borough) => (
	      <label key={borough} style={{
  fontSize: '1.3rem',
  marginRight: '5px',
  color: selectedColor === "rgba(51, 51, 51, 1)" ? 'white' : 'black'
}}>
          <input
            type="radio"
            name="borough"
            value={borough}
            checked={selectedBorough === borough}
            onChange={handleBoroughChange}
	    style={{ marginRight: '5px' }}   
          />
          {borough}
        </label>
      ))}
      <div className="date-selector">
        {getWeekDays().map((day, index) => (
          <button
            key={day.toISOString()}
            onClick={() => handleDateChange(day, index)}
            className="button"
            style={{
              backgroundColor: selectedDate.toDateString() === day.toDateString() ? colorMap[index % colorMap.length] : "#f0f0f0"
            }}
          >
            <div className="weekday">
              {day.toLocaleDateString("en-US", { weekday: "short" })}
            </div>
            <div className="date">{`${day.getMonth() + 1}/${day.getDate()}`}</div>
          </button>
        ))}
        {weekOffset === 0 && <button className="button"> </button>}
        {weekOffset > 0 && (
          <button
            onClick={() => handleWeekChange("previous")}
            className="button"
          >
            <div style={{ fontWeight: 'bold' }}>Last Week</div>
          </button>
        )}
        {weekOffset < 2 && (
          <button onClick={() => handleWeekChange("next")} className="button">
            <div style={{ fontWeight: 'bold' }}>Next Week</div>
          </button>
        )}
        {weekOffset === 2 && <button className="button"></button>}
      </div>
      <div>
        {Object.entries(filteredConcerts).map(([boroughName, concerts]) => (
          <div key={boroughName}>
		<h3 style={{ color: selectedColor === "#F0D878" ? "#FF00FF" :
                     selectedColor === "#A1CFCF" ? "#F58426" :
                     selectedColor === "#8FBC8F" ? "#8931e8" :
                     selectedColor === "#E6A8B8" ? "#2F4F4F" :
                     "white" }}>
                 {boroughName}
                </h3>
		<ul className="show-list" style={{ listStyleType: "none", padding: 0 }}>
              {concerts.map((concert) => (

			<li key={concert.id} style={{
  listStyleType: "none",
  marginBottom: "14px",
  textAlign: "center",
  borderLeftColor: getShowAccentColor(selectedColor)
}}>
  <div>
    {concert.artists.map((artist, index) => (
      <span key={index}>
        {index > 0 && ", "}
        {artist.band_website_url ? (
          <a href={artist.band_website_url} target="_blank" rel="noopener noreferrer">
            {artist.name}
          </a>
        ) : (
          artist.name
        )}
      </span>
    ))}

    {" @ "}

    <strong style={{ color: getVenueColor(selectedColor) }}>
      {concert.venue_name.website_url ? (
        <a href={concert.venue_name.website_url} target="_blank" rel="noopener noreferrer">
          {concert.venue_name.name}
        </a>
      ) : (
        concert.venue_name.name
      )}
    </strong>

    {concert.venue_name.neighborhood && (
  <span
    style={{
      color: "#FFD700",
      fontWeight: "bold"
    }}
  >
    {" • "}
    {concert.venue_name.neighborhood}
  </span>
)}


  </div>

  <div style={{
    marginTop: "4px",
    fontSize: "0.95rem",
    opacity: 0.9
  }}>
    {formatShowTime(concert.show_time) || "Time TBA"}

    {concert.show_url && (
      <>
        {" | "}
        <a 
          href={concert.show_url} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ fontSize: "20px", textDecoration: "none" }}
          title="Buy Tickets"
        >
          🎟️
        </a>
      </>
    )}
  </div>
</li>






              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConcertCalendar;
